import styled from 'styled-components'
import { grid, GridProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { LANDING_BASIC_HEADER_PADDING_INLINE } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !['gridTemplateColumns'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<GridProps>`
  display: grid;
  width: 100%;
  color: ${themeGet('colors.primary.main')};
  gap: ${themeGet('space.3')}px;
  padding-inline: ${themeGet(`space.${LANDING_BASIC_HEADER_PADDING_INLINE}`)}px;

  svg {
    flex-shrink: 0;
  }

  ${grid}
`
